import styles from "./dot.module.css";
import DotsImg from "../../../assets/imgs/dots.png";

export default function Dot2705() {
  return (
    <div className={styles.dot2705}>
      <img src={DotsImg} alt="circular-dots" />
    </div>
  );
}
